import { createSlice } from "@reduxjs/toolkit";

import { createApiThunk, updateState } from "../utilityFunction"

// Initial State
const initialState = {
    fetchHotDeals: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    saveHotDeals: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunk for Fetching Setting Data
export const fetchHotDealsData = createApiThunk("hotDeals", "fetch")
export const saveHotDealsData = createApiThunk("hotDeals", "save")

// Slice
const hotDealsSlice = createSlice({
    name: "hotDeals",
    initialState,

    reducers: {
        resetHotDealsState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchHotDeals = {
                    ...state.fetchHotDeals, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveHotDeals = {
                    ...state.saveHotDeals, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchHotDealsData.pending, (state) => updateState(state, "pending", "fetchHotDeals"))
            .addCase(fetchHotDealsData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchHotDeals", action.payload.data))
            .addCase(fetchHotDealsData.rejected, (state, action) =>
                updateState(state, "rejected", "fetchHotDeals", action.payload))
            // Save data
            .addCase(saveHotDealsData.pending, (state) => updateState(state, "pending", "saveHotDeals"))
            .addCase(saveHotDealsData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "saveHotDeals", action.payload.data))
            .addCase(saveHotDealsData.rejected, (state, action) =>
                updateState(state, "rejected", "saveHotDeals", action.payload));
    },
});

export const { resetHotDealsState } = hotDealsSlice.actions;
export default hotDealsSlice.reducer;
